import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'brand',
    serviceName: 'grapghql',
    query: gql`
      query brand($ids: [String]) {
        brand(ids: $ids) {
          data {
            title
            is_active
          }
        }
      }
    `,
  },
  update: {
    name: 'updateBrand',
    serviceName: 'admin',
    query: gql`
      mutation updateBrand(
        $ids: [String]!
        $title: String
        $code: String
        $details: String
        $is_active: Int
        $producer_id: String
      ) {
        updateBrand(
          ids: $ids
          title: $title
          code: $code
          details: $details
          is_active: $is_active
          producer_id: $producer_id
        ) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
